import { render, staticRenderFns } from "./MemberLiability.vue?vue&type=template&id=abdf0e22&scoped=true"
import script from "./MemberLiability.vue?vue&type=script&lang=js"
export * from "./MemberLiability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abdf0e22",
  null
  
)

export default component.exports